/* global document */
import { createRoot } from 'react-dom/client'

// React 18 replaced ReactDOM.render with createRoot. A root must be created
// once per container and reused, so we keep them keyed by DOM node.
//
// Turbolinks makes this trickier than a normal SPA: every `turbolinks:load`
// re-runs the pack code, and Turbolinks snapshots the DOM when you navigate
// away. If we leave a mounted React tree in the page, Turbolinks caches the
// rendered markup and later restores it without React attached, which shows
// stale buttons that no longer respond. So we unmount everything on
// `turbolinks:before-cache` and let the next `turbolinks:load` mount fresh.
const roots = new Map()

export default function mount(container, element) {
  if (!container) { return null }

  let root = roots.get(container)

  if (!root) {
    root = createRoot(container)
    roots.set(container, root)
  }

  root.render(element)

  return root
}

function unmountAll() {
  roots.forEach(root => root.unmount())
  roots.clear()
}

document.addEventListener('turbolinks:before-cache', unmountAll)
